<template>
  <v-card>
    <v-toolbar :color="enterpriseColor" dark min-height="85px" style="padding-top:10px;">
      <v-icon v-if="icon" style="margin-right:10px">{{ icon }}</v-icon>
      <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
      <v-spacer /><v-spacer /><v-spacer /><v-spacer />
      <v-text-field
        v-if="onSearch"
        v-model="search"
        append-icon="mdi-search"
        :label="$t('common.search')"
        hideDetails
        outlined
        @input="handleSearch"
        style="margin-right:20px"
      />
      <v-btn
        v-if="onAdd"
        class="mx-2" fab dark small :color="enterpriseColor"
        @click="onAdd"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-if="onSearch"
        v-model="search"
        append-icon="mdi-search"
        :label="$t('common.search')"
        singleLine
        hideDetails
        @input="handleSearch"
      ></v-text-field>
    </v-card-title> -->
    <v-data-table
      :loading="isLoading"
      loadingText="Loading... Please wait"
      :headers="headers"
      :items="items"
      hideDefaultFooter
    >
      <template v-slot:item.ident="{ item }">
        <a
          @click.stop.prevent="handleGoTo(item.ident.id)"
        >
          {{ item.ident.name }}
        </a>
      </template>
      <template v-slot:item.info="{ item }">
        <span style="color: red;">{{ item.info }}</span>
      </template>
      <template v-slot:item.token="{ item }">
        {{item}}
      </template>
      <template v-slot:item.actions="{ item }">
        <a
          @click.stop.prevent="handleGoTo(`common-menus/${item.ident.id}`)"
        >
          {{$t('enterprises.linkCommon')}}
        </a>
      </template>
    </v-data-table>
    <div
      v-if="pageCount > 0"
      class="text-center pt-2"
    >
      <v-pagination
        v-model="page"
        :length="pageCount"
        @input="handleChangePage"
        :color="enterpriseColor"
      />
    </div>
  </v-card>
</template>

<script>
  import _ from 'lodash'
  export default {
    props: {
      title: {
        type: String,
        required: false,
        default: null
      },
      icon: {
        type: String,
        required: false,
        default: null
      },
      headers: {
        type: Array,
        requerido: true
      },
      data: {
        type: Array,
        requerido: true
      },
      count: {
        type: Number,
        requerido: true
      },
      loading: {
        type: Boolean,
        requerido: false,
        default: false
      },
      onAdd: {
        type: Function,
        required: false,
        default: null
      },
      onSearch: {
        type: Function,
        required: false,
        default: null
      },
      onEdit: {
        type: Function,
        required: false,
        default: null
      }
    },
    data () {
      return {
        items: this.data,
        search: '',
        isLoading: this.loading,
        page: 1,
        itemsPerPage: 10
      }
    },
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      pageCount () {
        let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
        if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
        return page
      },
    },
    watch: {
      data: {
        handler: function (newValue) {
          this.items = newValue
        },
        deep: true
      }
    },
    created () {
      this.items = this.data
      this.handleSearch = _.debounce(() => {
        this.onSearch(this.search)
      }, 500)
    },
    methods: {
      handleGoTo (id) {
        if (this.onEdit) {
          this.onEdit(id)
        } else {
          this.$router.push(`${this.$route.path}/${id}`)
        }        
      },
      handleChangePage () {
        this.onSearch(this.search, this.page)
      }
    }
  }
</script>
